import {ValidationFailure, ValidationResult, ValidationSuccessful} from "./ValidationResult";
import {FormField} from "./FormField";
import BaseFormController from "./BaseFormController";

/**
 * Helpers for validation of whole form.
 */
export default class FormValidation {

	/**
	 * Validate many fields of a form.
	 * @param fields fields of the form.
	 * @param creator function converting data from fields to single object.
	 * @return validation result.
	 */
	static validateFields<T>(fields: [FormField<any>], creator: () => T): ValidationResult<T> {
		let formIsValid = true;
		fields.forEach(f => {
			const fieldIsValid = f.firstError().isEmpty;
			formIsValid = formIsValid && fieldIsValid;
		});

		if (formIsValid)
			return new ValidationSuccessful(creator());
		else
			return new ValidationFailure([])
	}

	/**
	 * Update one field of the form.
	 * @param form current form.
	 * @param updatedField updated field.
	 * @param copy method creation a copy of the form.
	 * @return new form.
	 */
	static updateField<T extends BaseFormController<any>>(form: T,
		updatedField: FormField<any>,
		copy: (form: T, config: {}) => T): T {
		let updateKey = "";
		Object.keys(form).forEach(key => {
			let field = (<any>form)[key];
			if (field.id) {
				if (field.id == updatedField.id)
					updateKey = key;
			}
		});

		return copy(form, {[updateKey]: updatedField});
	}

	/**
	 * Update many fields of the form.
	 * @param form current form.
	 * @param updatedFields updated fields.
	 * @param copy method creation a copy of the form.
	 * @return new form.
	 */
	static updateFields<T extends BaseFormController<any>>(form: T,
		updatedFields: FormField<any>[],
		copy: (form: T, config: {}) => T): T {
		let f = form;
		updatedFields.forEach(field => {
			f = FormValidation.updateField(f, field, copy);
		});
		return f;
	}

	/**
	 * Validate form.
	 * @param form form to validate.
	 * @param copy method creation a copy of the form.
	 * @return new form.
	 */
	static validateForm<T extends BaseFormController<any>>(form: T, copy: (form: T, config: {}) => T): T {
		let tmpForm = form;
		Object.keys(form).forEach(key => {
			let field: FormField<any> = (<any>tmpForm)[key];
			if (field.validate) {
				tmpForm = copy(tmpForm, {[key]: field.validate(form)})
			}
		});
		return tmpForm;
	}
}